import accountsFullcont  from "./accounts-fullcont.html";

const dialog          = require ('../../../../../components/dialog/dialog')
const fullcontEntity  = require ('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require ('../../../../../components/fullcont/fullcont-handler')
const accountsDt      = require('./accounts-dt')
const accountsMenu    = require('./accounts-menu')
const {formCopy}      = require('./accounts-fullcont-form') 
const {form}          = require('./accounts-fullcont-form')
const handler         = require('./accounts-fullcont-handler')
const report          = require('./accounts-fullcont-report')
const snack           = require('../../../../../components/snack/snack')
// const {accountsMT} = require('./accounts-fullcont-multitable')
const accountsMT      = undefined //no MT just add this like undefined
const { generateImage } = require('../../../../../components/avatar/avatar-generator')

/****************ELEMENTS*****************/
var htmlFc          = {}
var HTMLwasSelected = false

function HTMLselect(detail){ 

	fullcontHandler.HTMLselect(

            'accounts', //database table name****
            'accounts', //dest entity on js
            'accounts-fullcont', 
             accountsFullcont, form, formCopy, accountsMT, 
             editDialog, deleteDialog, dtCall, htmlFc)

	HTMLwasSelected   = true  

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/

export function start(detail){  //console.log('accounts-dt 5>', detail)
  
      if(!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/

const obj = {

      addOne:           { start: (detail)=>{  addOne(detail, htmlFc)                                          }},
      cancelEdit:       { start: (detail)=>{
            if (fullcontEntity.cancelEdit(detail, htmlFc)) report.returnToEntity(htmlFc)
      }},
      deleteEntity:     { start: (detail)=>{  fullcontEntity.deleteEntity(detail, htmlFc)                     }},
      deleteFromDialog: { start: (detail)=>{  deleteFromDialog(detail, htmlFc)                                }},
      discard:          { start: (detail)=>{
            report.reset(htmlFc)
            fullcontHandler.discard(detail, htmlFc)
      }},
      fullcontOptions:  { start: (detail)=>{  accountsMenu.start(detail, 'htmlDt', htmlFc )                   }},
      hide:             { start: (detail)=>{  hide(detail)                                                   }},
      prepareAdd:       { start: (detail)=>{  prepareAdd(detail, htmlFc)                                      }},
      prepareEdit:      { start: (detail)=>{  fullcontHandler.prepareEdit(detail, htmlFc)                     }},
      saveFromDialog:   { start: (detail)=>{  validate(detail)                                                }},
      selectOne:        { start: (detail)=>{  selectOne(detail)                                              }},
      editOne:          { start: (detail)=>{  selectOne(detail, true)                                        }},
      filterTransactions: { start: ()=>{     report.filterTransactions(htmlFc)                              }},
      selectOneNoCheck: { start: (detail)=>{
            report.cancelRequest(htmlFc)
            fullcontEntity.selectOneNoCheck(detail, htmlFc, () => {
                  report.reset(htmlFc)
                  syncBankInformation()
                  report.load(htmlFc)
            })
      }},
      showCheckPrintingGuide: { start: ()=>{  handler.showCheckPrintingGuide(htmlFc)                          }},
      toggleBankInformation: { start: ()=>{   handler.toggleBankInformation(htmlFc)                           }},
      validateRoutingNumber: { start: ()=>{   handler.validateRoutingNumber(htmlFc)                           }},
      update:           { start: (detail)=>{  validate(detail)                                                }},

}/**/

//function to send
function editDialog(){
	dialog.start({ act:"show", id:"saveChanges", entity:'accounts' } )
}

function deleteDialog(detail){
	dialog.start({ act:"show",  dest:'accounts', id:"deleteElem", entity:'accounts', dbid: detail.dbid } )
}

function dtCall(act, result){ 
	if (act === 'addRow' || act === 'updateRow') {
            report.reset(htmlFc)
            report.load(htmlFc)
      }
	accountsDt.start({act:act, row: result})
}

function validate(detail) {
      const result = handler.validate(detail, htmlFc)
      // Un Update sin cambios tambien vuelve a mode-view; no dejar abierto un tab oculto.
      if (htmlFc.fullcontHTML.classList.contains('mode-view')) report.returnToEntity(htmlFc)
      return result
}

function addOne(detail, htmlFc){

      if (!handler.validate(detail, htmlFc)) { return }
      setTimeout(()=>{
           // accountsDt.start({"dest":"accounts", "elem":"dt", "act":"select", "entity":"accounts"})  
      },100)  
      generateImage(detail, htmlFc);
                   
}

function prepareAdd(detail, htmlFc) {
      report.cancelRequest(htmlFc)
      fullcontEntity.prepareAdd(detail, htmlFc, () => {
            report.reset(htmlFc)
            handler.setDefaultActive(htmlFc)
            syncBankInformation()
      })
}

// Abrir Entity y precargar el reporte en su pestana al recibir la cuenta.
function selectOne(detail, edit = false) {
      report.cancelRequest(htmlFc)
      fullcontEntity.selectOne(detail, htmlFc, () => {
            report.reset(htmlFc)
            syncBankInformation()
            if (edit) fullcontHandler.prepareEdit(detail, htmlFc)
            report.load(htmlFc)
      })
}

function hide(detail) {
      const hidden = fullcontEntity.hide(detail, htmlFc)
      if (hidden) report.reset(htmlFc)
      return hidden
}

function syncBankInformation() {
      handler.toggleBankInformation(htmlFc)
}

function deleteFromDialog(detail, htmlFc){
      if (parseInt(htmlFc.fullcontHTML.getAttribute('data-DBid')) > 99) {
            fullcontEntity.deleteFromDialog(detail, htmlFc) 
            setTimeout(()=>{
                  accountsDt.start({"dest":"accounts", "elem":"dt", "act":"select", "entity":"accounts"})  
            },900)  
      } else {
            snack.start({ act: 'show', id: 'accountidisless', });
      }                
}
